const accentGradient = {
  secondary: {
    primary: 'linear-gradient(140.14deg, #E6F3F9 0%, #E6F9F6 100%)',
    active:
      'linear-gradient(0deg, rgba(16, 60, 67, 0.1), rgba(16, 60, 67, 0.1)), linear-gradient(140.14deg, #E6F3F9 0%, #E6F9F6 100%)',
    hover:
      'linear-gradient(0deg, rgba(16, 60, 67, 0.05), rgba(16, 60, 67, 0.05)), linear-gradient(140.14deg, #E6F3F9 0%, #E6F9F6 100%)',
  },
  primary: {
    primary: 'linear-gradient(154.27deg, #0C7BAA -12.3%, #049986 87.56%)',
    hover:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), linear-gradient(154.27deg, #0186BF -12.3%, #01BFA7 87.56%)',
    active:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), linear-gradient(154.27deg, #0186BF -12.3%, #01BFA7 87.56%)',
  },
};

const orangeGradient = {
  primary: 'linear-gradient(154.27deg, #EF6626 -12.3%, #F0B71B 87.56%)',
  light:
    'linear-gradient(154.27deg, rgba(246, 123, 67, 0.2) -12.3%, rgba(255, 226, 80, 0.2) 87.56%)',
  dark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), linear-gradient(154.27deg, #FF5F14 -12.3%, #FFD500 87.56%)',
};

const greenGradient = {
  primary: 'linear-gradient(154.27deg, #01BF9C -12.3%, #A2D522 87.56%)',
  light:
    'linear-gradient(154.27deg, rgba(1, 191, 156, 0.2) -12.3%, rgba(162, 213, 34, 0.2) 87.56%)',
  dark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), linear-gradient(154.27deg, #03B494 -12.3%, #61D905 87.56%)',
};

const blueGradient = {
  primary: 'linear-gradient(154.27deg, #AE7DF2 -12.3%, #4586C2 87.56%)',
  light:
    'linear-gradient(154.27deg, rgba(174, 125, 242, 0.2) -12.3%, rgba(69, 134, 194, 0.2) 87.56%)',
  dark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), linear-gradient(154.27deg, #AE7DF2 -12.3%, #4586C2 87.56%)',
};

const purpleGradient = {
  primary: 'linear-gradient(154.27deg, #E745D4 -12.3%, #9E3BEA 87.56%)',
  light:
    'linear-gradient(154deg, rgba(231, 69, 212, 0.20) -12.3%, rgba(158, 59, 234, 0.20) 87.56%)',
  dark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), linear-gradient(154.27deg, #E745D4 -12.3%, #9E3BEA 87.56%)',
};

const lightGradient = {
  primary:
    'linear-gradient(140.14deg, rgba(230, 243, 249, 0.4) 0%, rgba(230, 249, 246, 0.4) 100%)',
  text: 'linear-gradient(140.14deg, #E6F3F9 0%, #E6F9F6 100%), linear-gradient(0deg, rgba(16, 60, 67, 0.1), rgba(16, 60, 67, 0.1))',
};

export const gradients = {
  blueGradient,
  lightGradient,
  greenGradient,
  accentGradient,
  orangeGradient,
  purpleGradient,
};
